import React from 'react'

function CheckmarkIconRed() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <g clipPath="url(#clip0_8793_661)">
        <path d="M10.5 1.74219C8.76942 1.74219 7.07769 2.25537 5.63876 3.21683C4.19983 4.17829 3.07832 5.54485 2.41606 7.14371C1.75379 8.74256 1.58051 10.5019 1.91813 12.1992C2.25575 13.8966 3.08911 15.4557 4.31282 16.6794C5.53653 17.9031 7.09563 18.7364 8.79296 19.0741C10.4903 19.4117 12.2496 19.2384 13.8485 18.5761C15.4473 17.9139 16.8139 16.7924 17.7754 15.3534C18.7368 13.9145 19.25 12.2228 19.25 10.4922C19.25 8.17154 18.3281 5.94595 16.6872 4.305C15.0462 2.66406 12.8206 1.74219 10.5 1.74219ZM9.25 13.9864L6.125 10.8614L7.11913 9.86719L9.25 11.9979L13.8813 7.36719L14.8786 8.35838L9.25 13.9864Z" fill="#F4F4F4"/>
      </g>
      <defs>
        <clipPath id="clip0_8793_661">
          <rect width="20" height="20" fill="white" transform="translate(0.5 0.492188)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default CheckmarkIconRed
